// Thin wrapper around Google Analytics (gtag.js, loaded in index.html).
// No-ops safely when gtag is unavailable (ad blockers, script load failure).

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
  }
}

type EventParams = Record<string, string | number | boolean>

function send(...args: unknown[]) {
  if (typeof window.gtag === 'function') {
    window.gtag(...args)
  }
  if (import.meta.env.DEV) {
    console.debug('[analytics]', ...args)
  }
}

/** Common params attached to every hit; debug_mode surfaces dev traffic in GA DebugView */
function withDefaults(params: EventParams): EventParams {
  return import.meta.env.DEV ? { ...params, debug_mode: true } : params
}

/**
 * Virtual page view for SPA screen changes
 * (splash, theater_select, placement, battle, results, stats).
 */
export function trackScreen(screen: string) {
  send('event', 'page_view', withDefaults({
    page_title: screen,
    page_path: `/${screen}`,
    page_location: `${window.location.origin}/${screen}`,
  }))
}

/** Custom gameplay event (theater_selected, game_start, ships_placed, game_complete, ...) */
export function trackEvent(name: string, params: EventParams = {}) {
  send('event', name, withDefaults(params))
}
